/**
 * Container — centres page content and caps its width.
 *
 * WHY: on a wide monitor, text and cards stretched edge-to-edge look broken
 * and are hard to read. Capping the width (max-w-6xl) and centring keeps the
 * layout comfortable on any screen. Every page wraps its content in this, so
 * the gutter is identical everywhere.
 */

import { cn } from '@/lib/cn';

export function Container({ children, className }) {
  return <div className={cn('mx-auto w-full max-w-6xl px-4', className)}>{children}</div>;
}

/** A consistent page heading block used at the top of most pages. */
export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between gap-4 py-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-ink">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export default Container;
